// extracted by mini-css-extract-plugin
export default {"container":"InputPrograms_container__QxWkN"};